import * as React from "react";
import useTranslations from "../../hooks/useTranslations";
import useViewer from "../../hooks/useViewer";
import { ScreenHeader } from "../wombat-ui";
import { DashboardIcon } from '../icons';
import { Tag } from "@chakra-ui/react";

const ActivityHeader = () => {
  const t = useTranslations();
  const { company } = useViewer();

  return (
    <ScreenHeader
      title={company.name}
      description={
        <div className="pt-2">
          <Tag>
            {t("activity.metrics.collaborators", { count: company.users.length })}
          </Tag>
        </div>
      }
      icon={DashboardIcon}
    />
  )
};

export default ActivityHeader;
